import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { ComposerLoadingSkeleton } from '@tribeplatform/react-components/Messaging'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

import { ChatListLoading } from './ChatListLoading.js'

export const MessagingLayoutLoading = () => {
  const { $t } = useI18n()

  return (
    <div className="flex h-full bg-surface sm:rounded-base shadow">
      {/* Left sidebar */}
      <div className="min-w-64 w-full sm:max-w-xs sm:shrink-0">
        <Sidebar size="auto" className="sm:rounded-s-md">
          <Sidebar.Content className="p-0">
            <Tabs.Group selectedIndex={0}>
              <div className="sticky top-0 z-10 bg-surface flex flex-col">
                <div className="flex items-center justify-between border-b border-line-subdued p-3">
                  <div className="font-medium text-lg truncate text-content grow leading-10">
                    <T id="Generics.Inbox" defaultMessage="Inbox" />
                  </div>
                  <div className="flex space-x-2 items-center">
                    <div className="flex gap-x-1">
                      <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
                      <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
                      <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
                    </div>
                    <div className="w-8 h-8 bg-skeleton rounded-base animate-pulse"></div>
                  </div>
                </div>
                <Tabs.List variant="filled" className="p-3">
                  <Tabs.Tab
                    selected
                    name={$t({
                      id: 'Generics.Chats',
                      defaultMessage: 'Chats',
                    })}
                  >
                    <T id="Generics.Chats" defaultMessage="Chats" />
                  </Tabs.Tab>
                  <Tabs.Tab
                    className="!font-normal !text-sm"
                    name={$t({
                      id: 'Messaging.Sidebar.ArchivedChats',
                      defaultMessage: 'Archived Chats',
                    })}
                  >
                    <T
                      id="Messaging.Sidebar.ArchivedChats"
                      defaultMessage="Archived Chats"
                    />
                  </Tabs.Tab>
                </Tabs.List>
              </div>
              <Tabs.Panels className="!mt-0 overflow-auto">
                <Tabs.Panel>
                  <ChatListLoading />
                </Tabs.Panel>
              </Tabs.Panels>
            </Tabs.Group>
          </Sidebar.Content>
        </Sidebar>
      </div>

      {/* Main chat area */}
      <div className="flex-1 flex-col hidden sm:flex">
        {/* Header */}
        <div className="p-3 flex items-center justify-between border-b border-line-subdued">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-skeleton rounded-base animate-pulse"></div>
            <div className="h-4 bg-skeleton rounded-base w-32 animate-pulse"></div>
          </div>
          <div className="flex gap-x-1">
            <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
            <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
            <div className="w-1 h-1 bg-skeleton rounded-base animate-pulse"></div>
          </div>
        </div>

        {/* Chat messages */}
        <div className="flex-1 flex flex-col items-center justify-center p-4">
          <div className="h-5 bg-skeleton rounded-base w-32 mb-2 animate-pulse"></div>
          <div className="h-5 bg-skeleton rounded-base w-32 mb-2 animate-pulse"></div>
          <div className="h-4 bg-skeleton rounded-base w-64 animate-pulse"></div>
        </div>

        <ComposerLoadingSkeleton />
      </div>
    </div>
  )
}
